import { gql } from "@apollo/client";

export default gql`
  mutation markMeetingTopicsAsDiscussedMutation($meetingId: Int!) {
    markMeetingTopicsAsDiscussed(meetingId: $meetingId) {
      meeting {
        id
        topics {
          edges {
            node {
              id
              state
            }
          }
        }
      }
    }
  }
`;
